'use client'

export function CopilotSection() {
  return (
    <section
      className="overflow-hidden bg-black py-16 md:py-32"
      style={{ fontFamily: 'var(--font-ppmori, PPMori), sans-serif' }}
    >
      {/* Text — right-aligned */}
      <div className="mx-auto max-w-5xl px-6">
        <div className="ml-auto max-w-xl space-y-4 text-right">
          <p className="text-xs font-medium uppercase tracking-widest text-[#ffb703]/70">
            Copilot
          </p>
          <h2 className="text-4xl font-medium text-white lg:text-5xl">
            Set your strategy. Watch it fly.
          </h2>
          <p className="text-lg text-white/50">
            Build automated trading agents on a visual canvas — no code. Chain signal feeds,
            AI filters, risk rules, and execution nodes into a live strategy that runs 24/7.
          </p>
        </div>
      </div>

      {/* Video — recedes toward top-right with tighter perspective */}
      <div
        className="mt-12 pr-8 lg:pr-44"
        style={{ perspective: '900px' }}
      >
        <div
          style={{
            transform: 'rotateX(18deg) skewX(-13deg)',
            transformOrigin: 'top right',
            maskImage:
              'linear-gradient(to bottom, black 50%, transparent 100%), linear-gradient(to left, black 70%, transparent 100%)',
            WebkitMaskImage:
              'linear-gradient(to bottom, black 50%, transparent 100%), linear-gradient(to left, black 70%, transparent 100%)',
            maskComposite: 'intersect',
            WebkitMaskComposite: 'source-in',
          }}
          className="pr-6 pt-6"
        >
          {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
          <video
            src="/previews/autopilot.mov"
            autoPlay
            muted
            loop
            playsInline
            className="w-full border border-white/10 object-cover shadow-2xl"
          />
        </div>
      </div>
    </section>
  )
}
